import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {

  constructor() { }
}

@Injectable({
  providedIn: 'root'
})

// https://stackoverflow.com/questions/26501688/a-typescript-guid-class
export class Guid {
  public static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export class General {
  //
}

export class EmergencyTradeTypes {
  readonly Plumbing: number = 1;
  readonly Electrical: number = 2;
  readonly Locksmith: number = 3;
}

export class JobTypes {
  readonly DishwasherInstallationWithOptionalDisposal: number = 1;
  readonly LightSwitchInstallation: number = 9;
  readonly InternalPowerPointInstallation: number = 11;
  readonly ExternalPowerPointInstallation: number = 13;
  readonly ExtractorFanInstallation: number = 15;
  readonly InstallingAirConditioningHeatPump: number = 52;
  readonly OvenInstallationWithOptionalDisposal: number = 87;
  readonly ToiletInstallationWithOptionalDisposal: number = 88;
  readonly VanityInstallationWithOptionalDisposal: number = 89;
}

export class TradeTypes {
  readonly Unknown: number = 0;
  readonly Plumbing: number = 1;
  readonly Electrical: number = 2;
  readonly Locksmith: number = 3;
  readonly Handyman: number = 4;
  readonly HomeInspections: number = 5;
  readonly Glazing: number = 6;
  readonly Carpentry: number = 7;
  readonly Plastering: number = 8;
  readonly Painting: number = 9;
  readonly HVAC: number = 10;
  readonly RoofPlumbing: number = 11;
  readonly Fencing: number = 12;
  readonly BrickLaying: number = 13;
  readonly BrickPaving: number = 14;
  readonly Antennas: number = 15;
  readonly StormReadiness: number = 16;
  readonly Tiling: number = 17;
  readonly Gardening: number = 18;
  readonly GarageDoors: number = 19;
  readonly SpecialOffers: number = 20;
  
  readonly GutterCleaning: number = 22;
  
  readonly AAHealthyHomeInspection: number = 21;
  readonly AABuildingInspection: number = 23;
  readonly AARentalInspection: number = 24;
  readonly AAMethamphetamineInspection: number = 25;
  readonly AAAsbestosInspection: number = 26;

  readonly AAFlatPackAssembly: number = 27;
  readonly MovingService: number = 28;
  readonly CarpetCleaningService: number = 29;
}

export class Clients {
  readonly Demo: number = 0;
  readonly AANZ: number = 3978;

  constructor() { }
}

export class QuestionTypes {
  readonly FreeText: number = 1;
  readonly BookingWindows: number = 2;
  readonly ContactDetails: number = 3;
  readonly Confirmation: number = 4;
  readonly Quantity: number = 5;
  readonly TwoOptions: number = 6;
  readonly SelectTapModel: number = 7;
  readonly Numeric: number = 8;
  readonly YesNo: number = 9;
  readonly SimpleTwoOptions: number = 10;
  readonly HandymanDuration: number = 11;
  readonly JobNotesPhotos: number = 12;
  readonly CarpentryDuration: number = 13;
  readonly PlasteringDuration: number = 14;
  readonly PaintingDuration: number = 15;
  readonly HVACDuration: number = 16;
  readonly RoofPlumbingDuration: number = 17;
  readonly FencingDuration: number = 18;
  readonly BrickLayingDuration: number = 19;
  readonly BrickPavingDuration: number = 20;
  readonly AntennasDuration: number = 21;
  readonly StormReadinessText: number = 22;
  readonly TilingDuration: number = 23;
  readonly PaintingWholeApartment: number = 24;
  readonly PaintingSingleRoom: number = 25;
  readonly GardeningDuration: number = 26;
  readonly GutterCleaningDuration: number = 27;
  readonly SolarCleaningDuration: number = 28;
  readonly AirConditioningDuration: number = 29;
  readonly SmokeAlarmDuration: number = 30;
  readonly StandardPremium: number = 31;
  readonly TwoOptionStandardPremium: number = 32;
  readonly FreeTextPlusCommonJobs: number = 33;
  readonly Redirect: number = 34;
  readonly DwellingType: number = 35;
}

export enum ServiceTypes {
  // plumbing
  ReplacementKitchenLaundryTap = 2,
  ReplacementGardenTap = 3,
  ReplacementBathroomTap = 4,
  ReplacementTapWashers = 0,
  ReplacementDishwasher = 1,
  NoHotWater = 5, // emergency
  UnblockToiletDrain = 6, // emergency
  BurstPipe = 7, // emergency
  PlumbingGeneral = 8,
  
  // electrical
  ReplaceLightSwitch = 9,
  InstallNewInternalPowerPoint = 10,
  ReplaceInternalPowerPoint = 11,
  InstallNewExternalPowerPoint = 12,
  ReplaceExternalPowerPoint = 13,
  ReplaceCeilingFan = 14,
  InstallNewExhaustFan = 15,
  ReplaceSmokeAlarm = 16,
  InstallExtraInternetPoint = 17,
  ElectricalGeneral = 18,

  // single service trades
  Locksmith = 19,
  Handyman = 20,
  Plastering = 21,
  Painting = 22,
  HVAC = 23,
  RoofPlumbing = 24,
  Fencing = 25,
  BrickLaying = 26,
  BrickPaving = 27,
  Carpentry = 28,
  Glazing = 29,
  HomeInspections = 30,
  Antennas = 31,
  Gardening = 32,
  GarageDoors = 35,
  
  // painting
  PaintingWholeApartment = 33,
  PaintingSingleRoom = 34,
  
  //special offers
  GutterCleaning = 36,
  SolarCleaning = 37,
  AirConditioning = 38,
  SmokeAlarm = 39,
  
  //HVAC Services
  MaintenanceService = 50,
  AirConditioningHeatPumpNotWorking = 51,
  InstallingAirConditioningHeatPump = 52,
  HVACGeneral = 53,
  
  // AANZ Healthy Home Services
  HHPropertySize1to199 = 54,
  HHPropertySize200To299 = 55,
  HHPropertySize300To399 = 56,
  HHHouseWithSleepout = 57,
  HHMinorDwellingSameTenancy = 58,
  HHMinorDwellingDifferentTenancy = 59,
  HHOther = 60,
  
  // AANZ Building Inspection Services
  NZ_BI_PROPERTYTO149 = 61,
  NZ_BI_PROPERTYTO199 = 62,
  NZ_BI_PROPERTYTO249 = 63,
  NZ_BI_UNDER150PLUSS = 64,
  NZ_BI_UNDER150PLUSMD = 65,
  NZ_BI_UNDER150PLUSFD = 66,
  NZ_BI_OTHER = 86,

  // AANZ Rental Inspection Services
  NZ_RI_PROPERTYTO199 = 67,
  NZ_RI_PROPERTYTO299 = 68,
  NZ_RI_PROPERTYTO399 = 69,
  NZ_RI_MINORDWELLINGS = 70,
  NZ_RI_MINORDWELLINGD = 71,
  NZ_RI_OTHER = 72,
  
  // AANZ Methamphetamine Testing Services
  NZ_MT_PROPERTYTO200 = 73,
  NZ_MT_PROPERTYTO400 = 74,
  NZ_MT_PROPERTYTO600 = 75,
  NZ_MT_TWODWELLINGS = 76,
  NZ_MT_THREEDWELLINGS = 77,
  NZ_MT_FOURDWELLINGS = 78,
  NZ_MT_OTHER = 79,

  // AANZ Asbestos Testing Services
  NZ_AT_ONESAMPLE = 80,
  NZ_AT_TWOSAMPLES = 81,
  NZ_AT_THREESAMPLES = 82,
  NZ_AT_FOURSAMPLES = 83,
  NZ_AT_FIVESAMPLES = 84,
  NZ_AT_OTHER = 85,
  
  PLACEHOLDER_NEXT = 87,
}

export enum JobChannelType {
  ONLINE = 1,
  ADMIN = 2,
  TMC = 3,
  CALLCENTRE = 4,
}
